<template>
  <div class="dashboard">
    <b-modal 
      id="modal-success"
      size="lg"
      centered 
      title="Félicitations !" 
      title-class="text-center"
      header-bg-variant="primary" 
      header-text-variant="light" 
      :visible="completedTraining && !displayedSuccessModal"
      :hide-header-close="true"
      :no-close-on-backdrop="true"
      modal-class="text-center"
      :ok-only="true"
      ok-title="J'ai compris"
      ok-variant="secondary"
      @ok="closeModal"
    >
      <p>Vous avez terminé votre formation !</p>
      <p>Vous pouvez à présent retrouver votre certificat complet, au format numérique, grâce au lien "Mon certificat" qui apparaît dans la barre de navigation comme sur l'image ci-dessous.</p>
      <b-col class="text-center">
        <b-row class="d-none d-lg-block">
          <img src="@/assets/screenshot_certificate_link_desktop.jpg" class="screenshot"/>
        </b-row>
        <b-row  class="d-lg-none">
          <img src="@/assets/screenshot_certificate_link_mobile.jpg" class="screenshot"/>
        </b-row>
      </b-col>
      <p style="margin-top:0.5rem">Ce lien vous permet de consulter, télécharger et imprimer votre certificat. Vous pouvez également le partager autour de vous pour montrer votre réussite.</p>
      <p v-if="!isPlusUser && DcPlusModules.length>0" style="border-top: solid #D1D3D4 1px; padding-top: 1rem">Vous avez désormais la possibilité de souscrire à <u>Digital Citizen Plus</u> pour débloquer de nouveaux modules d'apprentissage et approfondir davantage vos connaissances informatiques. Pour cela, veuillez vous rapprocher de votre centre de formation.</p>
    </b-modal>
    <h1>Mon tableau de bord</h1>

      <b-card
        v-show="nbModulesCompleted>0 && profileSurveyProgress<100 && modulesLoaded==true && $parent.$parent.loadedProfileSurvey==true"
        align="center"
        no-body
        id="profile-reminder"
      >
        <b-card-body>
          <b-row align-v="center">
            <b-col class="d-flex align-items-start flex-column justify-content-center">
              <strong v-if="surveyStep==1">Pensez à finaliser votre profil</strong>
              <strong v-if="surveyStep==2">Votre évolution professionnelle après 6 mois avec la certification Digital Citizen</strong>
              <strong v-if="surveyStep==5">Votre évolution professionnelle après 12 mois avec la certification Digital Citizen</strong>
              <small class="font-italic mt-1">Temps estimé : {{estimateSurveyDuration}}</small>
              <b-progress :value="profileSurveyProgress" variant="secondary" height="4px" striped animated class="w-100"></b-progress>
            </b-col>
            <b-col md="3">
              <b-button
                v-if="surveyStep==1"
                :to="{ name: 'ProfilFormation' }"
                variant="secondary"
                class="rounded-pill align-middle"
                block
              >
                <b-icon icon="exclamation-circle-fill" variant="danger" animation="fade" class="text-danger fade-animation bg-light" name="exclamation-circle" style="position:absolute; top:-5px; left:7px; width:20px; height:20px; border-radius:30px;"></b-icon>
                Compléter mon profil
              </b-button>
              <b-button
                v-else
                :to="{ name: 'SuiviProfessionnel', params: { surveyStep: surveyStep } }"
                variant="secondary"
                class="rounded-pill align-middle"
                block
              >
                <b-icon icon="exclamation-circle-fill" variant="danger" animation="fade" class="text-danger fade-animation bg-light" name="exclamation-circle" style="position:absolute; top:-5px; left:7px; width:20px; height:20px; border-radius:30px;"></b-icon>
                Compléter mon suivi
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-card
        v-show="modulesLoaded==true"
        :class="'practical-exercise '+practriceProgress"
        align="center"
        no-body
      >
        <b-card-header v-b-toggle.practical-collapse header-bg-variant="info" header-text-variant="dark">
          <h4>Exercices pratiques <b-icon-chevron-down></b-icon-chevron-down></h4>
        </b-card-header>
        <b-collapse id="practical-collapse" :visible="showPracticalExercise" @show="updatePracticalCollapseState(true)" @hide="updatePracticalCollapseState(false)">
          <b-card-body id="practical-body">
            <p v-if="email==null || password!='encrypt'" style="font-size:1.05rem;">Vous avez terminé l'apprentissage du module "Communication par internet" ? Exercez vous, en pratiquant ces tâches courantes à l'utilisation d'internet.</p>
            <b-card-text class="pl-5 pr-2">
              <b-icon v-if="email==null" icon="exclamation-circle-fill" variant="warning" class="rounded-circle bg-light"></b-icon>
              <b-icon v-else icon="check-circle-fill" variant="success" class="rounded-circle bg-light"></b-icon>
              <b> Renseignez et confirmez votre adresse email</b> <br>
              <span v-if="email==null">Après avoir créé votre adresse email, rendez-vous sur la page "Mes informations" pour enregistrer et confirmer votre adresse email dans votre compte Digital Citizen.</span>
            </b-card-text>
            <b-card-text class="pl-5 pr-2">
              <b-icon v-if="password!='encrypt'" icon="exclamation-circle-fill" variant="warning" class="rounded-circle bg-light"></b-icon>
              <b-icon v-else icon="check-circle-fill" variant="success" class="rounded-circle bg-light"></b-icon>
              <b> Personnalisez votre mot de passe</b> <br>
              <span v-if="password!='encrypt'">Grâce à la page "Mes informations" personnalisez le mot de passe de votre compte Digital Citizen, après avoir confirmé votre adresse email.</span>
            </b-card-text>
            <p v-if="email==null || password!='encrypt'" class="font-weight-bold">Pour vous aider, n'hésitez pas à vous reporter au chapitre "Le courrier électronique" de votre support de formation.</p>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card
        v-show="modulesLoaded==true"
        :class="'dc-modules '+dcClass"
        align="center"
        no-body
      >
        <b-card-header v-b-toggle.dc-collapse header-bg-variant="info" header-text-variant="dark">
          <h4>Digital Citizen <b-icon-chevron-down></b-icon-chevron-down></h4>
        </b-card-header>
        <b-collapse id="dc-collapse" :visible="showDcModules" @show="updateDcCollapseState(true)" @hide="updateDcCollapseState(false)">
          <b-card-body id="dc-body">
            <b-row class="module-section">
              <moduleCard v-for="m in DcModules" :key="m.id" :module="m" lg="3" md="5" xm="12" xs="12"/>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card
        v-if="displayDcPlusModules && DcPlusModules.length>0"
        v-show="modulesLoaded==true"
        :class="'dcplus-modules '+dcplusClass"
        align="center"
        no-body
      >
        <b-card-header v-b-toggle.dcplus-collapse header-bg-variant="info" header-text-variant="dark">
          <h4>Digital Citizen Plus <b-icon-chevron-down></b-icon-chevron-down></h4>
        </b-card-header>
        <b-collapse id="dcplus-collapse" :visible="showDcplusModules" @show="updateDcplusCollapseState(true)" @hide="updateDcplusCollapseState(false)">
          <b-card-body id="dcplus-body">
            <b-row class="module-section">
              <moduleCard v-for="m in DcPlusModules" :key="m.id" :module="m" lg="3" md="5" xm="12" xs="12"/>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
  </div>
</template>

<script>
import Store from '@/store/index.js'
import ModuleCard from '@/components/ModuleCard.vue'
import api from '@/services/api.js'

export default {
  methods: {
    getRandomPercentage() {
      return Math.floor(Math.random() * 100)
    },
    closeModal() {
        Store.dispatch("set_displayed_success_modal")
    },
    updatePracticalCollapseState(state) {
      Store.dispatch("set_show_practical_exercise", state)
    },
    updateDcCollapseState(state) {
      Store.dispatch("set_show_dc_modules", state)
    },
    updateDcplusCollapseState(state) {
      Store.dispatch("set_show_dcplus_modules", state)
    }
  },
  data () {
    return {
      DcModules: [],
      DcPlusModules: [],
      modulesLoaded: false,
      displayDcPlusModules : false
    }
  },
  computed: {
    completedTraining() {return Store.getters.getCompletedTraining()},
    email() {
      let email= Store.getters.getEmail()
      return (email=="" || email==null)? null : email
    },
    password() {
      let password= Store.getters.getPassword()
      return (password=="" || password==null || password!="encrypt")? null : "encrypt"
    },
    displayedSuccessModal () {return Store.getters.getDisplayedSuccessModal()},
    showPracticalExercise () {
      let state = Store.getters.getShowPracticalExercise()
      if (typeof state != "boolean") {
        state = (state == 'false')? false : true;
      }
      return state
    },
    showDcModules () {
      return Store.getters.getShowDcModules()
    },
    showDcplusModules () {
      return Store.getters.getShowDcplusModules()
    },
    modulesList () {
      if (this.isPlusUser) {
        return this.DcModules.concat(this.DcPlusModules);
      }
      else {
        return this.DcModules;
      }
    },
    isPlusUser() {return Store.getters.getIsPlus()},
    practriceProgress() {return (this.password!=null && this.email!=null)? "completed-practice" : "unfinished-practice"},
    dcProgress() {
      let sum = 0
      let nbDcModules = 0
      this.DcModules.forEach(dcModule => {
        nbDcModules++;
        sum += parseInt(dcModule.completion);
      });
      return nbDcModules>0? sum/nbDcModules : 0;
    },
    dcplusProgress() {
      let sum = 0
      let nbDcPlusModules = 0
      this.DcPlusModules.forEach(dcPlusModule => {
        nbDcPlusModules++;
        sum += parseInt(dcPlusModule.completion);
      });
      return nbDcPlusModules>0? sum/nbDcPlusModules : 0;
    },
    dcClass() {return (this.dcProgress==100)? 'completed-practice' : 'unfinished-practice'},
    dcplusClass() {
      if(this.dcProgress >=100 && this.isPlusUser) {
        return (this.dcplusProgress==100)? 'completed-practice' : 'unfinished-practice'
      }
      else {return ''}
    },
    profileSurveyProgress() {return this.$parent.$parent.profileSurveyProgress},
    estimateSurveyDuration() {
      if (this.profileSurveyProgress<25) {
        return "moins de 2 minutes"
      }
      else if (this.profileSurveyProgress<40) {
        return "environ 1 minute"
      }
      else if (this.profileSurveyProgress<100) {
        return "moins d'1 minute"
      }
      else {
        return ""
      }
    },
    nbModulesCompleted() {return this.$parent.$parent.nbModulesCompleted;},
    surveyStep() {return this.$parent.$parent.surveyStep;}
  },
  name: 'Dashboard',
  components: {
    ModuleCard,
  },
  beforeCreate() {
    this.$parent.$parent.setLoading(true, "Chargement de votre tableau de bord")
    if(this.isPlusUser==null) {
      api.get('/user/')
      .then(response=> {
        if (response.data[0].lsa_plus_id && response.data[0].lsa_plus_id>0) {
          Store.dispatch("update_plus_status", true)
        }
        else {
          Store.dispatch("update_plus_status", false)
        }
        if (response.data[0].email) {
          Store.dispatch("update_email", response.data[0].email)
        }
        if (response.data[0].password) {
          Store.dispatch("update_password", response.data[0].password)
        }
      })
    }
    api.get('/module/')
    .then(response=> {
      Object.values(response.data[0]).forEach(m => {
        if (m.module.is_plus == true) {
          this.DcPlusModules.push(m)
        }
        else {
          this.DcModules.push(m)
        }
      });
      this.modulesLoaded=true
      this.$parent.$parent.setLoading(false)
    })
  },
  mounted() {
    },
  watch: {
    modulesList: function() {
      if(this.modulesLoaded==true && this.modulesList!=[]) {
        Store.dispatch("update_nb_modules_completed", this.modulesList.filter(module => module.completion >= 100).length)
        // Store.dispatch("set_display_certificate_link", this.modulesList)
        Store.dispatch("set_display_dc_certificate_link", this.modulesList.filter(module => !module.module.is_plus))
        if (this.isPlusUser) {
          Store.dispatch("set_display_dcplus_certificate_link", this.modulesList.filter(module => module.module.is_plus))
        }
        Store.dispatch("set_completed_training", this.modulesList)
      }
    },
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
  margin-bottom: 20px;
}
h3, h4 {
  font-weight: bold;
}
#plus-title {
  margin-top: 30px
}
.module-section {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.card-title {
  margin-bottom: 20px
}
.screenshot {
  max-width: 100%;
}
.modal-content {
  text-align: center;
}
.card-header {
  font-weight: 600;
}
#profile-reminder {
  margin: auto 10px;
}
.practical-exercise, .dc-modules, .dcplus-modules {
  margin: 30px 10px 0;
}
.practical-exercise .card-body {
  text-align: left;
}
.completed-practice {
  border-left: 5px solid #78BE20;
}
.unfinished-practice {
  border-left: 5px solid #F2A900;
}
</style>
